export default __webpack_public_path__ + "static/tb3Lyguo-f4cc359d28499e6b0548fd500fa25c55.jpeg";